import controller from './bill-info.controller';

export default {
  bindings: {
    invoice: '<',
    packet: '<',
    promocode: '='
  },
  controller,
  template: require('./bill-info.html')
};



// WEBPACK FOOTER //
// src/app/buy/bill-info/info/bill-info.component.ts